import { Component } from '@angular/core';
import { NavController, NavParams } from 'ionic-angular';
import {AddressPage} from "../address/address";
import {UserService} from "../../app/services/user.service";
import {RegisterPage} from "../register/register";
import {PhonenumberPage} from "../phonenumber/phonenumber";
import {FavoritePage} from "../favorite/favorite";
import {AnalyticsService} from "../../app/services/analytics.service";
import {UserOrdersPage} from "../user-orders/user-orders";

/*
  Generated class for the Profile page.

  See http://ionicframework.com/docs/v2/components/#navigation for more info on
  Ionic pages and navigation.
*/
@Component({
  selector: 'page-profile',
  templateUrl: 'profile.html',
  providers: [UserService]
})
export class ProfilePage {

  constructor(private analytics : AnalyticsService, public userService : UserService, public navCtrl: NavController, public navParams: NavParams) {

  }

  ionViewDidLoad(){
    this.analytics.trackView("Profile");
  }

  viewAddress(){
    this.userService.get().then((u) => {
      console.log(u);
    });

    this.navCtrl.push(AddressPage);
  }

  viewPhonenumber(){
    this.userService.get().then((user) => {
      if (user.account.verified){
        this.navCtrl.push(PhonenumberPage)
      } else {
        this.navCtrl.push(RegisterPage);
      }
    });
  }
  /*viewFavorites(){
    this.navCtrl.push(FavoritePage);
  }*/
  viewOrders(){
    this.navCtrl.push(UserOrdersPage);
  }
}



// WEBPACK FOOTER //
// ./src/pages/profile/profile.ts